import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { Configuracion } from '../../configuracion/configuracion.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { CambioDolarCompra } from '../../configuracion/cambioDolarCompra.model';

@Component({
  selector: 'app-cambio-dolar-compra',
  templateUrl: './cambio-dolar-compra.component.html',
  styleUrls: ['./cambio-dolar-compra.component.scss']
})
export class CambioDolarCompraComponent implements OnInit  {

  @Input() cambioDolarCompra: CambioDolarCompra;
  @Output() onUpdateDolarCompra = new EventEmitter<boolean>();
  staticCambioDolarCompra = { valor: null };
  operationalCambioDolarCompra = { valor: null };

  staticDolaresCompra: Configuracion[];
  isLoading: boolean;

  constructor(
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService
  ) { }

  hasCambioDolarCompra() {
    if (this.staticCambioDolarCompra.valor !== null) {
      return true;
    }
    return false;
  }

  async confirmCambioDolarCompra() {
      this.dialogService.confirm('Modificar cotización dolar',
      '¿Está seguro que desea modificar la cotización actual de compra del dólar?')
      .then( res => {
        if (res) {
          this.save(res);
        }
      });
  }

  async save(res) {
    if (res) {
      this.snackService.spinner(true);
      try {
        await this.backendService.changeDolarCompra('/configuraciones/cambio_dolar_compra?dolar='
                                                      + this.operationalCambioDolarCompra.valor);
        this.snackService.success('Cotización actualizada');
        this.updateView();
        this.snackService.spinner(false);
      } catch (error) {
        this.snackService.spinner(false);
        this.snackService.error(error.message);
      }
    }
  }

  updateView() {
    this.getDolarCompraHistorico();
    this.staticCambioDolarCompra.valor = this.operationalCambioDolarCompra.valor;
  }

  ngOnInit() {
    this.backendService.getDolarCompra('/configuraciones/dolar_compra').then(
      res => {
        this.staticCambioDolarCompra.valor = res;
      }
    );

    this.getDolarCompraHistorico();

    if (this.cambioDolarCompra) {
      this.staticCambioDolarCompra.valor = this.cambioDolarCompra.valor;
      this.operationalCambioDolarCompra.valor = this.cambioDolarCompra.valor;
    }
  }

  async getDolarCompraHistorico() {
    this.backendService.getDolarCompraHistorico('/configuraciones/dolar_compra_historico').then(
      res => {
        this.staticDolaresCompra = res as [Configuracion];
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/cambio-dolar-compra/cambio-dolar-compra.component.ts